import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui";
import { cn } from "@/utils";

interface CriticalErrorStateProps {
	title: string;
	message?: string | null;
	actionLabel: string;
	onAction: () => void;
	className?: string;
}

export function CriticalErrorState({
	title,
	message,
	actionLabel,
	onAction,
	className,
}: CriticalErrorStateProps) {
	return (
		<div
			className={cn(
				"flex items-center justify-center min-h-screen bg-bg-secondary",
				className,
			)}
		>
			<div className="text-center p-6 max-w-md">
				<div className="mb-4 text-danger">
					<AlertTriangle className="w-12 h-12 mx-auto" />
				</div>
				<h2 className="text-lg font-semibold text-text-primary mb-2">
					{title}
				</h2>
				{message && (
					<p className="text-sm text-text-secondary mb-4">{message}</p>
				)}
				<Button variant="primary" size="sm" onClick={onAction}>
					{actionLabel}
				</Button>
			</div>
		</div>
	);
}
